// Configuration de l'API
const API_CONFIG = {
  // URL de base de l'API
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  
  // Endpoints
  endpoints: {
    updates: '/api/updates',
    news: '/api/news',
    announcements: '/api/announcements',
  },
  
  // Configuration par défaut
  defaultOptions: {
    timeout: 10000, // 10 secondes
    retryAttempts: 3,
    retryDelay: 1000,
    cacheTime: 5 * 60 * 1000, // 5 minutes
  },
  
  // Headers par défaut
  defaultHeaders: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

// Fonction pour construire l'URL complète
const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`;
};

// Fonction pour obtenir la configuration
const getApiConfig = () => {
  return API_CONFIG;
};

// Fonction pour obtenir les headers avec authentification si nécessaire
const getHeaders = (additionalHeaders = {}) => {
  const headers = { ...API_CONFIG.defaultHeaders, ...additionalHeaders };
  
  // Ajouter le token d'authentification depuis la config
  if (API_CONFIG.authToken) {
    headers.Authorization = `Bearer ${API_CONFIG.authToken}`;
  }
  
  // Ajouter le token d'authentification depuis localStorage si disponible (fallback)
  const localToken = localStorage.getItem('authToken');
  if (localToken && !headers.Authorization) {
    headers.Authorization = `Bearer ${localToken}`;
  }
  
  return headers;
};

// Fonction pour gérer les erreurs d'API
const handleApiError = (error) => {
  console.error('Erreur API:', error);
  
  if (error.name === 'TypeError' && error.message.includes('fetch')) {
    return 'Erreur de connexion au serveur';
  }
  
  if (error.status === 401) {
    return 'Session expirée, veuillez vous reconnecter';
  }
  
  if (error.status === 403) {
    return 'Accès refusé';
  }
  
  if (error.status === 404) {
    return 'Ressource non trouvée';
  }
  
  if (error.status >= 500) {
    return 'Erreur serveur, veuillez réessayer plus tard';
  }
  
  return error.message || 'Une erreur inattendue s\'est produite';
};

// Exports
export { buildApiUrl, getApiConfig, getHeaders, handleApiError };
export default API_CONFIG; 